package nl.astraeus.wiki.view

import kotlinx.browser.window
import kotlinx.html.a
import kotlinx.html.div
import nl.astraeus.css.properties.AlignItems
import nl.astraeus.css.properties.Display
import nl.astraeus.css.properties.rem
import nl.astraeus.komp.HtmlBuilder
import nl.astraeus.wiki.css.Css
import nl.astraeus.wiki.css.Css.defineCss
import nl.astraeus.wiki.css.CssId
import nl.astraeus.wiki.css.CssName
import nl.astraeus.wiki.messages.GetOAuthInfoMessage
import nl.astraeus.wiki.messages.MessageType
import nl.astraeus.wiki.messages.OAuthInfoMessage
import nl.astraeus.wiki.messages.OAuthType
import nl.astraeus.wiki.oauth.OauthClient
import nl.astraeus.wiki.ws.WebsocketConnection

// https://docs.github.com/en/apps/oauth-apps/building-oauth-apps/authorizing-oauth-apps
class Login : Modal("Login") {
  var google: OauthClient? = null

  init {
    WebsocketConnection.send(GetOAuthInfoMessage(OAuthType.GOOGLE)) { msg ->
      msg.checkType(MessageType.OAUTH_INFO_RESPONSE)

      val oauthMessage = OAuthInfoMessage(msg.message)

      google = oauthMessage.toOauthClient()
      requestUpdate()
    }
  }

  override val confirmText: String = "Login"

  override val confirmListener: () -> Unit = {}

  override val size: ModalSize = ModalSize.EXTRA_SMALL

  override fun HtmlBuilder.renderContent() {
    div(LoginFormCss.name) {
      val gogle = google
      if (gogle != null) {
        a(GoogleButtonCss.name) {
          +"Login with Google"

          href = """
            https://accounts.google.com/o/oauth2/v2/auth?
            client_id=${gogle.clientId}&
            redirect_uri=${window.location.origin}/oauth/google&
            response_type=code&
            scope=email+profile&
            state=${gogle.oauthState}
            """.trimIndent().replace("\n", "")
        }
      } else {
        div {
          +"Loading..."
        }
      }
    }
  }

  companion object : CssId("login-register") {
    object LoginLabelCss : CssName
    object LoginFormCss : CssName
    object LoginFormGroupCss : CssName
    object LoginInputCss : CssName
    object GoogleButtonCss : CssName

    init {
      defineCss {
        select(LoginFormGroupCss.cls()) {
          margin(0.8.rem, 0.rem)
          display(Display.flex)
          alignItems(AlignItems.center)
        }
        select(LoginLabelCss.cls()) {
          width(10.rem)
          marginRight(0.6.rem)
        }
        select(LoginFormCss.cls()) {
          margin(1.2.rem, 0.rem)
        }
        select(LoginInputCss.cls()) {
          border("none")
          outline("none")
          borderRadius(Css.currentStyle.cardBorderRadius)
          padding(0.6.rem)
        }
        select(GoogleButtonCss.cls()) {
          border("1px solid black")
          padding(0.6.rem)
        }
      }
    }
  }

}
